import React, {Fragment} from "react";
import {Col, FormGroup, Label, Row} from "reactstrap";

const QaCategoryForm = (props) => {
    const {errors, register} = props;

    return (
        <Fragment>
            <Row>
                <Col>
                    <FormGroup>
                        <Label className="col-form-label">Title<span style={{color: "red"}}>*</span></Label>
                        <input name="title" type="text" {...register('title')} className={`form-control ${errors.title ? 'is-invalid' : ''}`}/>
                        <div className="invalid-feedback">{errors.title?.message}</div>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <Label className="col-form-label">Sort Order</Label>
                        <input name="sort_order" type="number" {...register('sort_order')} className={`form-control ${errors.sort_order ? 'is-invalid' : ''}`}/>
                        <small className="text-muted">Controls the tab order on the storefront (lowest first).</small>
                        <div className="invalid-feedback">{errors.sort_order?.message}</div>
                    </FormGroup>
                </Col>
            </Row>
        </Fragment>
    );
};

export default QaCategoryForm;
